export default (permalink, category, title, date, sourceUrl, counter) => `

<a href="${permalink}" class="single-action">
    <div class="single-action-inner">
        <div class="action-type rounded">
            <span>${category}</span>
        </div>
        <div class="action-title">
            <h4>${title}</h4>
        </div>
        <div class="action-date">
            <span>${date}</span>
        </div>
        <div class="action-image" style="background: url(${sourceUrl}) center center / cover no-repeat;">
            <div class="overlay"></div>
        </div>
    </div>
</a>
`;